import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { PASSWORD_RULES } from '../utils/kernelPassword';
import KernelCapsLockWarning from './KernelCapsLockWarning';
import './kernelPassword.css';

const EyeIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const RuleIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path className="password-rule-check" d="m8 12.2 2.8 2.8L16 9.5" />
  </svg>
);

/**
 * Elenco dei requisiti della password: ogni riga si spunta (verde) appena la password scritta la rispetta.
 * Si mette sotto il campo (o sotto la coppia password/conferma): <KernelPasswordRules value={form.password} />.
 */
export function KernelPasswordRules({ value }) {
  const { t } = useLanguage();
  const password = value || '';
  return (
    <ul className="password-rules" aria-live="polite">
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li key={rule.key} className={'password-rule' + (ok ? ' is-ok' : '')}>
            <span className="password-rule-icon">{RuleIcon}</span>
            <span>
              {t(`passwordRules.${rule.key}`)}
              <span className="sr-only">{ok ? ` — ${t('passwordRules.met')}` : ''}</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}

/**
 * Campo password con l'occhio per vedere quello che si sta scrivendo
 * (usato da Profilo, Utenti e Utenti dell'azienda). Stili: .password-input-wrapper / .password-toggle.
 */
function KernelPasswordField({ label, value, onChange, required, autoComplete, style }) {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const toggleTitle = visible ? t('profile.hidePassword') : t('profile.showPassword');
  return (
    <div className="form-group" style={style}>
      <label>{label}</label>
      <div className="password-input-wrapper">
        <input
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          className={'password-toggle' + (visible ? ' is-off' : '')}
          onClick={() => setVisible((v) => !v)}
          title={toggleTitle}
          aria-label={toggleTitle}
          aria-pressed={visible}
        >
          {visible ? EyeOffIcon : EyeIcon}
        </button>
      </div>
      <KernelCapsLockWarning />
    </div>
  );
}

export default KernelPasswordField;
